import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { GetFabAdditionalImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQuery.type';
import { getFabAdditionalImagesQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const AdditionalImagesList = ({
  state,
}: {
  state: GetFabAdditionalImagesQueryParamsType['state'];
}) => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getFabAdditionalImagesQueryOptions({
      id: id!,
      state,
      damagedId,
    }),
  );

  return (
    <>
      {!imagesData?.vehicle?.length &&
      !imagesData?.damaged?.length &&
      !imagesData?.document?.length &&
      !imagesData?.damaged_parts?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : null}
      {imagesData?.vehicle?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر وسیله‌نقلیه
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.vehicle?.map((vehicleImages, index) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'attachment',
                      index,
                    }),
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
      {imagesData?.damaged?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر زیان‌دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.damaged?.map((damagedImages, index) => {
              return (
                <ImageCard
                  key={damagedImages.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'attachment',
                      index,
                    }),
                    src: damagedImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
      {imagesData?.document?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            مدارک
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.document?.map((documentImages, index) => {
              return (
                <ImageCard
                  key={documentImages.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'document',
                      index,
                    }),
                    src: documentImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
      {imagesData?.damaged_parts?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            نقاط آسیب دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.damaged_parts?.map((damagedPartsImages) => {
              return (
                <ImageCard
                  key={damagedPartsImages.id}
                  imageData={{
                    name: damagedPartsImages.title?.fa_const,
                    src: damagedPartsImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
    </>
  );
};

export default AdditionalImagesList;
